import matchQuestionComplexity from "./match_question_complexity";

import {LlmRunScore, SingleTestResult} from "common/flowmaster/types/llm_run";
import {ProblemComplexityKey, QueryDomain} from "common/types/query_domain";
import {GroupedScores, questionComplexities} from "../types";

import updateScore from "./update_score";

export default function groupScores(
  runScores: LlmRunScore[],
  groupByBatchOnly: boolean,
): GroupedScores {
  const initialValue: GroupedScores = {groups: {}, ungrouped: []};
  return runScores.reduce((acc, runScore) => {
    if (!runScore.problem_complexity_pass_state) {
      acc.ungrouped.push(runScore);
      return acc;
    }
    const passState = runScore.problem_complexity_pass_state;
    Object.entries(runScore.problem_complexity_pass_state).forEach(
      ([pComplexityKey, runResults]) => {
        if (runScore.query_domain) {
          const qComplexityKey = groupByBatchOnly
            ? runScore.batch_id
            : matchQuestionComplexity(
                runScore.query_domain,
                questionComplexities,
              );
          if (qComplexityKey) {
            if (!acc.groups[qComplexityKey]) {
              acc.groups[qComplexityKey] = {};
            }
            if (!acc.groups[qComplexityKey][pComplexityKey]) {
              acc.groups[qComplexityKey][pComplexityKey] = {score: 0, runs: []};
            }
            const oldScore = acc.groups[qComplexityKey][pComplexityKey];
            const newScore = updateScore(
              oldScore,
              runScore,
              addParentResults(
                runResults.results,
                pComplexityKey,
                passState,
                runScore.query_domain,
              ),
            );
            acc.groups[qComplexityKey][pComplexityKey] = newScore;
          } else {
            acc.ungrouped.push(runScore);
          }
        } else {
          acc.ungrouped.push(runScore);
        }
      },
    );
    return acc;
  }, initialValue);
}
function addParentResults(
  results: SingleTestResult[],
  problemComplexityKey: ProblemComplexityKey,
  problemComplexityPassState: Record<string, {results: SingleTestResult[]}>,
  queryDomain: QueryDomain,
): SingleTestResult[] {
  const parentProblemComplexityKey: ProblemComplexityKey | undefined =
    queryDomain.problem_complexity[problemComplexityKey]?.extends;
  if (!parentProblemComplexityKey) {
    return results;
  }
  return addParentResults(
    [
      ...results,
      ...problemComplexityPassState[parentProblemComplexityKey].results,
    ],
    parentProblemComplexityKey,
    problemComplexityPassState,
    queryDomain,
  );
}
